import { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from 'yup'
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { ERROR_MSG } from "../../CommonUtils/contextVariables";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
import { failureAlert } from "../../CommonUtils/SweetAlerts";
import CommonReactTable from "../../CommonUtils/CommonReactTable";
import { viewImage } from "../../CommonUtils/viewImage";
import { BsFiletypePdf } from "react-icons/bs";


export default function NonOAMDdrill(props) {
    const hasFetchedData = useRef(false)
    const acYear = sessionStorage.getItem('ac_year');

    const [data, setData] = useState([])
    const [row, setRow] = useState([])
    const dispatch = useDispatch()
    const validations = Yup.object({
        remarks: Yup.string().required(ERROR_MSG)
    })

    const formik = useFormik({
        initialValues: {
            remarks: ''
        },
        validationSchema: validations,
        onSubmit: () => {
            let payload = {
                empId: row?.original?.emp_id,
                remarks: formik.values.remarks
            }
            let url = config.url.API_URL + `DeleteEmployee`
            CommonAxiosPost(url, payload, dispatch).then((res) => {
                if (res.data.scode === '01') {
                    Swal.fire('Deleted Successfully', '', 'success').then((succ) => {
                        if (succ?.isConfirmed) {
                            window.location.reload()
                        }
                    })
                }
                else {
                    failureAlert("Failed to submit")

                }
            })
        }
    })
    const { ubcode, start, end, Setdrilldown } = props
    function GetData() {
        let url = config.url.API_URL + `getcollegesreportdrill/` + ubcode + '/' + start + '/' + end
        CommonAxiosGet(url, dispatch).then((res) => {
            if (res?.data?.scode === '01') {
                setData(res?.data?.data)

            }
        })
    }


    function NonOamdcCOllegePdf(collegecode) {
        let url = config.url.API_URL + `getAffiliationPdf/` + collegecode + "/" + acYear;
        CommonAxiosPost(url, dispatch).then((res) => {
            if (res?.data?.Status === true) {
                viewImage(res?.data?.path)
            }
            else {
                console.log(res);
            }
        })
    }
    const Columns = [
        {
            Header: "Sl.no",
            accessor: (row, index) => index + 1,
        },
        {
            Header: "College Code",
            accessor: "coll_code",
            Cell: ({ row }) => <div style={{ textAlign: 'left' }}>{row?.values?.coll_code ? row?.values?.coll_code : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "College Name",
            accessor: "inst_name",
            Cell: ({ row }) => <div style={{ textAlign: 'left' }}>{row?.original?.inst_name}</div>
        },
        {
            Header: "Phone no(s)",
            accessor: "phone_nos",
            Cell: ({ row }) => <div style={{ textAlign: 'left' }}>{row?.values?.phone_nos ? row?.values?.phone_nos : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Approval",
            accessor: "approval_section",
            Cell: ({ row }) => <div style={{ width: '80px' }}>{row?.values?.approval_section ? row?.values?.approval_section : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Application",
            accessor: "application_category",
            Cell: ({ row }) => <div>{row?.original?.application_category}</div>
        },
        {
            Header: "Society",
            accessor: "society_details_confirmed",
            Cell: ({ row }) => <div>{row?.original?.society_details_confirmed}</div>

        },
        {
            Header: "College Details",
            accessor: "college_details_confirmed",
            Cell: ({ row }) => <div>{row?.values?.college_details_confirmed ? row?.values?.college_details_confirmed : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Society Land Allotments",
            accessor: "society_land_allotment",
            Cell: ({ row }) => <div>{row?.values?.society_land_allotment ? row?.values?.society_land_allotment : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },

        {
            Header: "Geo Location",
            accessor: "geo_location",
            Cell: ({ row }) => <div>{row?.values?.geo_location ? row?.values?.geo_location : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "College Building Related",
            accessor: "college_building_related",
            Cell: ({ row }) => <div>{row?.original?.college_building_related}</div>
        },
        {
            Header: "Building Blocks",
            accessor: "building_blocks",
            Cell: ({ row }) => <div style={{ width: '80px' }}>{row?.values?.building_blocks ? row?.values?.building_blocks : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Infrastructural Area",
            accessor: "instructional_area",
            Cell: ({ row }) => <div style={{ width: '80px' }}>{row?.values?.instructional_area ? row?.values?.instructional_area : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Administrative Area",
            accessor: "administrative_area",
            Cell: ({ row }) => <div>{row?.original?.administrative_area}</div>
        },
        {
            Header: "Class Room Area Calculation",
            accessor: "class_room_area_caluculation",
            Cell: ({ row }) => <div>{row?.original?.class_room_area_caluculation}</div>

        },
        {
            Header: "Course Intake",
            accessor: "course_intake",
            Cell: ({ row }) => <div>{row?.values?.course_intake ? row?.values?.course_intake : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Acadamic Performance",
            accessor: "academic_performance",
            Cell: ({ row }) => <div>{row?.values?.academic_performance ? row?.values?.academic_performance : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Teaching Staff",
            accessor: "teaching_staff",
            Cell: ({ row }) => <div>{row?.values?.teaching_staff ? row?.values?.teaching_staff : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Non Teaching Staff",
            accessor: "non_teaching_staff",
            Cell: ({ row }) => <div>{row?.original?.non_teaching_staff}</div>
        },
        {
            Header: "Lab Area",
            accessor: "lab_area",
            Cell: ({ row }) => <div style={{ width: '80px' }}>{row?.values?.lab_area ? row?.values?.lab_area : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Lab Course Mapping",
            accessor: "lab_course_mapping",
            Cell: ({ row }) => <div style={{ width: '80px' }}>{row?.values?.lab_course_mapping ? row?.values?.lab_course_mapping : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Lab Equipment",
            accessor: "lab_equipment_details",
            Cell: ({ row }) => <div>{row?.original?.lab_equipment_details}</div>
        },
        {
            Header: "College Facilities",
            accessor: "college_facilities",
            Cell: ({ row }) => <div>{row?.original?.college_facilities}</div>

        },
        {
            Header: "Other Infrastructural",
            accessor: "other_infrastructural",
            Cell: ({ row }) => <div>{row?.values?.other_infrastructural ? row?.values?.other_infrastructural : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Financial Details",
            accessor: "financial_details",
            Cell: ({ row }) => <div>{row?.values?.financial_details ? row?.values?.financial_details : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Fee Status",
            accessor: "fee_status",
            Cell: ({ row }) => <div>{row?.values?.fee_status ? row?.values?.fee_status : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Affadavit Upload",
            accessor: "affidavit_upload",
            Cell: ({ row }) => <div>{row?.values?.affidavit_upload ? row?.values?.affidavit_upload : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "College Application Pdf",
            Cell: ({ row }) => <div style={{ color: 'blue', textAlign: 'right' }} onClick={() => { NonOamdcCOllegePdf(row?.original?.coll_code,) }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        NonOamdcCOllegePdf(row?.original?.coll_code,)
                    }
                }}
            ><BsFiletypePdf size={23} /></div>
        },



    ]
    useEffect(() => {
        if (!hasFetchedData.current) {
            GetData()
            hasFetchedData.current = true
        }
    }, [])

    return (
        <>



            <Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5 " style={{ backgroundColor: '#FAF7F0' }}  >
                <Row>
                    <Col xs={11} sm={11} md={11} lg={11} xl={11} xxl={11} className="d-flex justify-content-between align-items-center">
                        <div className="inner-herbpage-service-title-sub pt-0"  >
                            <h1 className="m-0 p-0 pb-2">{start === '100' || '0' ? start : start + '-' + end} Percentage Report</h1>
                        </div>
                    </Col>
                    <Col xs={1} sm={1} md={1} lg={1} xl={1} xxl={1}>
                        <button type="button" className="btn btn-primary float-end" onClick={() => { Setdrilldown(0) }}>Back</button>
                    </Col>
                </Row>
                <br></br>
                {data && data?.length > 0 ? (
                    <CommonReactTable data={data} columns={Columns} excelFlag={true} printFlag={true} filename="College Application Submission Percentage Report" headerName='' />
                ) : (
                    <b className='text-error text-center'>No data Found</b>
                )}
            </Container>
        </>
    )
}
